import { useEffect, useState, useCallback } from "react";
import api from "../lib/api";

export default function useSubscription() {
  const [sub, setSub] = useState(null);
  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/me/subscription");
      setSub(data);
    } catch (e) {
      setSub(null);
    }
  }, []);
  useEffect(() => { refresh(); }, [refresh]);
  return { sub, refresh };
}
